import React from 'react'
import { Link } from 'react-router-dom'

class FormNuevo extends React.Component {

    state = {}

    // This is the handle of the checkbox
    checkear() {
        if(this.props.form.used){
            this.props.form.used = false
        }
        else{
            this.props.form.used = true
        }
    }

    // Render the checkbox checked or uncheked dependiendo del estado
    renderCheckBox = (checkeado) => {
        if(checkeado){
            return(
                <input className="form-check-input" type="checkbox" name="used" id="usadoCheck"
                onClick={() => this.checkear() } defaultChecked value={this.props.form.used}/>
            )
        }
        else{
            return(
                <input className="form-check-input" type="checkbox" name="used" id="usadoCheck"
                onClick={() => this.checkear()} value={this.props.form.used}/>
            )
        }
    }

    render(){
        // Declaring props as the same as the father class
        const { onChange, onSubmit, form, pageInfo} = this.props

        // Begins the render function
        return (
            <>
                <div className="container mt-3">
                        <h2 className="text-center">{pageInfo.title}</h2>
                        <form onSubmit={onSubmit}>
                            <div className="form-row">
                                <div className="form-group col-md-3">
                                    <label htmlFor="inputMarca">Marca</label>
                                    <input type="text" className="form-control" name="brand" placeholder="Marca" id="inputMarca"
                                    onChange={onChange}
                                    value={form.brand}/>
                                </div>
                                <div className="form-group col-md-3">
                                    <label htmlFor="inputModelo">Modelo</label>
                                    <input type="text" className="form-control" name="model" placeholder="Modelo" id="inputModelo"
                                    onChange={onChange}
                                    value={form.model}/>
                                </div>
                                <div className="form-group col-md-3">
                                    <label htmlFor="inputYear">Año</label>
                                    <input type="number" className="form-control" name="year" placeholder="Año" id="inputYear"
                                    onChange={onChange}
                                    value={form.year}/>
                                </div>
                                <div className="form-group col-md-3">
                                    <label htmlFor="inputPrecio">Precio</label>
                                    <input type="number" className="form-control" name="price" placeholder="Precio" id="inputPrecio"
                                    onChange={onChange}
                                    value={form.price}/>
                                </div>
                                <div className="form-group col-md-3">
                                    <label htmlFor="inputColor">Color</label>
                                    <input type="text" className="form-control" name="color" placeholder="Color" id="inputColor"
                                    onChange={onChange}
                                    value={form.color}/>
                                </div>
                                <div className="form-group col-md-3">
                                    <label htmlFor="inputKm">Kilometraje</label>
                                    <input type="number" className="form-control" name="km" placeholder="Kilometraje" id="inputKm"
                                    onChange={onChange}
                                    value={form.km}/>
                                </div>
                                <div className="form-group col-md-3">
                                    <label htmlFor="inputTransmission">Transmisión</label>
                                    <select className="form-control" name="transmission" id="inputTransmission"
                                    onChange={onChange}
                                    value={form.transmission}>
                                        <option value="Manual">Manual</option>
                                        <option value="Auto">Auto</option>
                                    </select>
                                </div>
                                <div className="form-group col-md-3">
                                    <label htmlFor="inputDoors">Puertas</label>
                                    <input type="number" className="form-control" name="doors" placeholder="Puertas" id="inputDoors"
                                    onChange={onChange}
                                    value={form.doors}/>
                                </div>
                                <div className="form-group col-md-3">
                                    <label htmlFor="inputGas">Tipo de gasolina</label>
                                    <select className="form-control" name="gas" id="inputGas"
                                    onChange={onChange}
                                    value={form.gas}>
                                        <option value="Normal">Normal</option>
                                        <option value="Solo Diesel">Solo Diesel</option>
                                    </select>
                                </div>
                                <div className="form-group col-md-3">
                                    <label htmlFor="inputFuelCap">Capacidad del tanque de gasolina</label>
                                    <input type="number" className="form-control" name="fuelCap" placeholder="Galones de disponibilidad"
                                        id="inputFuelCap"
                                        onChange={onChange}
                                        value={form.fuelCap}/>
                                </div>
                                <div className="form-group col-md-3">
                                    <label htmlFor="inputEngine">Motor</label>
                                    <input type="text" className="form-control" name="engine" placeholder="Motor" id="inputEngine"
                                    onChange={onChange}
                                    value={form.engine}/>
                                </div>
                                <div className="form-group col-md-3">
                                    <label htmlFor="inputHorse">Caballos de fuerza</label>
                                    <input type="number" className="form-control" name="horsepower" placeholder="Horse Power" id="inputHorse"
                                    onChange={onChange}
                                    value={form.horsepower}/>
                                </div>
                                <div className="form-group col-md-12">
                                    <label htmlFor="inputDesc">Descripción del carro</label>
                                    <input type="text" className="form-control" name="descrip" placeholder="Escribe una descripción"
                                        id="inputDesc"
                                        onChange={onChange}
                                        value={form.descrip}/>
                                </div>
                                <div className="form-group col-md-12">
                                    <label htmlFor="inputImage">Enlace de imagen</label>
                                    <input type="text" className="form-control" name="picturePath" placeholder="Pega el link aquí"
                                        id="inputImage"
                                        onChange={onChange}
                                        value={form.picturePath}/>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="form-check">
                                    {this.renderCheckBox(form.used)}
                                    <label className="form-check-label" htmlFor="usadoCheck">
                                        Carro usado
                                    </label>
                                </div>
                            </div>
                            <button type="submit" className="btn btn-success px-4 mb-3 mr-3">{pageInfo.buttonText}</button>
                            <Link to="/menu" className="btn btn-danger px-4 mb-3">Cancelar</Link>
                        </form>
                    </div>
            </>
            )
    }
}


export default FormNuevo